import { css } from 'styled-components';

export const PieChart = () => {
  return css`
    &,
    & .pie {
      width: 100%;
      height: 100%;
    }

    & .note {
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #fff0e4;
      color: #002169;
      padding: 8px 20px;
      font-size: 12px;
      width: fit-content;
      border-radius: 8px;
      gap: 4px;
      margin-inline: 40px;

      & span {
        color: #3156ff;
        font-size: 20px;
        transform: translateY(10%);
      }
    }
  `;
};
